import { Flex } from "@mantine/core";
import { memo } from "react";
import Barcode from "src/components/Barcode";

type IViewCode = {
  code: string;
};

function ViewCode({ code }: IViewCode) {
  return (
    <Flex justify={"center"} align={"center"}>
      <Barcode value={code} />
    </Flex>
  );
}

export default memo(ViewCode);
